export default "__VITE_ASSET__D12cuuH4__"